import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { FontService, FontOption } from '../../../core/services/font.service';

@Component({
  selector: 'app-settings',
  imports: [TranslatePipe],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {
  protected readonly fontService = inject(FontService);

  selectArabicFont(font: FontOption): void {
    this.fontService.setArabicFont(font.id);
  }

  selectUrduFont(font: FontOption): void {
    this.fontService.setUrduFont(font.id);
  }
}
